import { Divider, Box, p, Button, Avatar, Typography, Drawer } from "@mui/material";
import React, { useState, useEffect, useCallback, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Listcolor from "../assets/color";
import useMediaQuery from "@mui/material/useMediaQuery";
import BellSound from "../assets/bell_ring.mp3";
import PersonIcon from "@mui/icons-material/Person";
import { getUser } from "../../Model/LocalStorage";
import { auctionsLive, postPlaceBid,auctionsLiveDeclarator } from "../../Model/Auction";
import WebAssetIcon from '@mui/icons-material/WebAsset';
import Chat from "./chat";
import Drawer1 from "./drawer";
import ImageRows from "./ImageRows";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MessageIcon from "@mui/icons-material/Message";
import OnlinePredictionIcon from '@mui/icons-material/OnlinePrediction';
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TtyIcon from "@mui/icons-material/Tty";
import GridViewIcon from "@mui/icons-material/GridView";
import { getToken } from "../../Model/User";
import GavelIcon from '@mui/icons-material/Gavel';
import "./style.css";
// import { WebRTCPlayer } from "@eyevinn/webrtc-player";




import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { matchPath } from "react-router-dom";

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}



const date = new Date();

function RightLayout({ details, mediadQuery, socket, room,titleAuction }) {
  const token = getToken();
  const soundRef = useRef();
  const [loading, setLoading] = React.useState(false);
  const [Data, setData] = useState([]);
  const phoneMatch = useMediaQuery("(max-width:600px)");
  // const phoneMatch = useMediaQuery("width: 430px and height: 932px");
  const [userId, setUserId] = useState("");
  const [onlineUserID, setOnlineStatus] = useState(null);

  //  const [play] = useSound(BellSound);
  const [highestBid, setHighestBid] = useState(0);
  // const [disable, setDisable] = useState("");
  const [announcement, setAnnouncement] = useState("");
  const [dataAuction, setDataAuction] = useState([]);
  const [status, setStatus] = useState("");
  const [hammerPrice, setHammerPrice] = useState("");
  const [username, setUsername] = useState("");
  const [group, setGroup] = React.useState("");
  const [lotNumber, setlotNumber] = useState("");
  const [getData, setGetData] = useState([]);
  const [startPrice, setStartPrice] = useState("");
  const [bidhistory, setBidHistory] = useState([]);
  const [highestNumber, setHighest] = useState("");
  const [getbp, setGetBP] = useState("");
  const [setID, setIDset] = useState("");
  const [auctionID, setAuctionID] = useState("");
  const [pause, setPause] = React.useState(false);

  const [detailsAll1, setDetailsAll1] = useState("");
  // const [detailsAll2, setDetailsAll2] = useState("");
  // const [detailsAll3, setDetailsAll3] = useState("");
  // const [detailsAll4, setDetailsAll4] = useState("");

  const incrementCount = (auctionID, setID, lotNumber, highestBid) => {

    setStatus("PAUSE");
    try {
      async function postBidFunction() {
        // setStatus(true)
        const ArrayData = {
          auction_id: auctionID,
          setId: setID,
          lot_number: lotNumber,
          amount: highestBid,
        };

        // const resultsa = await postStatus(ArrayData);

        //   if (resultsa.success === true) {
        //     socket.emit("send_status", {
        //       status: true,
        //       message: "OPEN",
        //       nextCount: parseInt(lotNumber),
        //     });
        //   }else{

        //   }

        const results = await postPlaceBid(ArrayData);
        //  soundRef.current.play();
        if (results.success === true) {
          // alert(results.msg);
          const messageData = {
            room: room,
            status: results.success,
            amount: highestBid,
            increment: highestBid,
          };

          if (status === "FAIR_WARNING") {
            socket.emit("send_status", {
              message: "OPEN",
            });
          }

          socket.emit("send_Bid_amount", messageData);
        } else if (results === false) {
          alert(`Error !: ${results}`);
        } else {
          window.location.reload();
          // alert(`Error !: ${results}`);
          //alert(`Error dito!: ${results}`);
          // console.log("results: ", results);
          // alert('results');
        }
      }

      postBidFunction().catch(console.error);
    } catch (error) {
      // console.log("error in postBid: ", error);
    }
  };

  function SoundTrip() {
    var resp = new Audio(BellSound).play();

    if (soundRef !== undefined) {
      resp
        .then((_) => {
          resp.autoplay = true;
          resp.current.focus();
        })
        .catch((error) => {
          //show error
          //  console.log("error")
        });
    }
  }

  const playSound = (data) => {
    const datass = data.bid_history.filter(
      (x) => x.bidder_type === "INTERNET BIDDER"
    );
    function loopThroughSplittedText() {
      for (var i = 0; i < datass.length; i++) {
        // for each iteration console.log a word
        // and make a pause after it
        (function (i) {
          setTimeout(function () {
            document.getElementById("sound").click();
          }, 500 * i);
        })(i);
      }
    }
    loopThroughSplittedText();
  };

  const ListData = useCallback((val,group) => {
    try {
      setLoading(true);
      async function getAuctionOne() {

        
        let results;
        if(group === "ADMIN"){
           results = await auctionsLiveDeclarator();
        }else{
         results = await auctionsLive();
        }
        setLoading(false);
        if (results.success === false) {
          alert(results.msg);
        } else {
          if (val === "NEXTSLOT" || val === "PASS") {
            // setPause(results.lot.details[0].lot_status === "PAUSE" ? true : false);

            setGetData(results.lot.details);
            setData(results.auction_details);
            setBidHistory(results.bid_history);
            setIDset(results.auction_details.id);
            setAuctionID(results.auction_details.auction_id);
            setStatus(results.lot.details[0].lot_status);
            setDataAuction(results);
            setlotNumber(results.lot.details[0].lot_number);
            setGetBP(results.lot.details[0].bp);
            setStartPrice(results.lot.details[0].starting_price);
            setHighestBid(
              results.lot.details[0].hp === 0 ||
                results.lot.details[0].hp === null
                ? results.lot.details[0].starting_price
                : results.increment
            );
            setHammerPrice(
              results.lot.details[0].hp === null ? 0 : results.lot.details[0].hp
            );
            setHighest(Math.max(...results.bid_history.map((o) => o.hammer)));
            setAnnouncement(results.announcement[0].announcement);
            return playSound(results);
          } else {
            setPause(
              results.lot.details[0].lot_status === "PAUSE" ? true : false
            );
            setGetData(results.lot.details);
            setData(results.auction_details);
            setBidHistory(results.bid_history);
            setIDset(results.auction_details.id);
            setAuctionID(results.auction_details.auction_id);
            setStatus(results.lot.details[0].lot_status);
            setDataAuction(results);
            setlotNumber(results.lot.details[0].lot_number);
            setGetBP(results.lot.details[0].bp);
            setStartPrice(results.lot.details[0].starting_price);
            setHighestBid(
              results.lot.details[0].hp === 0 ||
                results.lot.details[0].hp === null
                ? results.lot.details[0].starting_price
                : results.increment
            );
            setHammerPrice(
              results.lot.details[0].hp === null ? 0 : results.lot.details[0].hp
            );
            setHighest(Math.max(...results.bid_history.map((o) => o.hammer)));
            setAnnouncement(results.announcement[0].announcement);
            //  return playSound(results);
          }
        }
      }
      getAuctionOne().catch(console.error);
    } catch (error) {}
  }, []);

  // useEffect(() => {
  //   socket.on("receive_bid_amount", (data) => {
  //     setBidderList(data);
  //   });
  // }, [socket]);

  const [detailsShow, setShowDtails] = useState(false);

  const handleDetails = () => {
    setShowDtails(true);
  };

  const [open1, setOpen1] = React.useState(true);
  const handleClose = () => {

    setShowDtails(false);
  };


  const handleCloseChat = () => {
    // setOpen1(!open1);
    setOpenChat(!openChat)
  };


  useEffect(() => {
    // reconnectPlayer();
    // const myVideo = document.querySelector('video');
    // // Not all browsers return promise from .play().
    // const playPromise = myVideo.play() || Promise.reject('');
    // if (playPromise !== undefined) {
    //   playPromise.then(_ => {
    //   })
    //   .catch(error => {
    //   });
    // }

    soundRef.current = new Audio(BellSound);

    socket.on("receive_bid_amount", (data) => {

      if (data.status === 1 || data.status === 2 ) {
        return ListData('',group);
        
      }else if (data.status === true) {
        document.getElementById("sound").click();

        // window.scrollTo(0, 0)
        return ListData('',group);
      } else {
      }
    });

  
    getUserList().catch(console.error);

    async function getUserList() {
      const getuser = await getUser();
      // alert(getuser.group)
      setGroup(getuser.group);
      setUserId(getuser.id);
      setUsername(getuser.email);
  
    }
    getUserList().catch(console.error);

    try {
      setGetData(details.lot.details);
      setGetBP(details.lot.details[0].bp);
      setData(details.auction_details);
      setBidHistory(details.bid_history);
      // console.log("results tawag: ", results);
      setIDset(details.auction_details.id);
      setAuctionID(details.auction_details.auction_id);
      setPause(details.lot.details[0].lot_status === "PAUSE" ? true : false);
      setStatus(details.lot.details[0].lot_status);
      setDataAuction(details);
      // alert(results.lot.details[0].lot_number)
      setlotNumber(details.lot.details[0].lot_number);
      setStartPrice(details.lot.details[0].starting_price);
      setHighestBid(
        details.lot.details[0].hp === 0 || details.lot.details[0].hp === null
          ? details.lot.details[0].starting_price
          : details.increment
      );
      setHammerPrice(
        details.lot.details[0].hp === null ? 0 : details.lot.details[0].hp
      );
      setHighest(Math.max(...details.bid_history.map((o) => o.hammer)));
      // setPlayerID(
      //   details.bid_history.filter((val) => val.userId === userId)[0].userId
      // );
      setDetailsAll1(
        details.lot.details[0].signed_dated +
          details.lot.details[0].medium +
          details.lot.details[0].size +
          details.lot.details[0].property
      );

      setAnnouncement(details.announcement[0].announcement);
    } catch (error) {
      setBidHistory(
        details.bid_history === undefined ? bidhistory : details.bid_history
      );
      // setGetData((details.auction_details === undefined ? getData:details.lot.details))
    }

    socket.on("receiveMessage", (data) => {
      setAnnouncement(data.message);
    });

    socket.on("receive_status", (data) => {
      if (data.message === "NEXTSLOT" || data.message === "PASS") {
        setPause(false);
        setTimeout(() => {
          return ListData(data.message);
        }, 1000);
      } else if (data.message === "undo") {
        setPause(false);
        return ListData();
      } else if (data.message === "fresh") {
        window.location.reload();
        setPause(false);
      } else if (data.message === "PAUSE") {
        setPause(true);
      } else {
        setPause(false);
        // alert(data.message)
        setStatus(data.message);
        //return ListData();
        // console.log("error in view receive_status");  window.location.reload();
      }
    });

    return () => {
      //socket.removeAllListeners();
      socket.off("receive_bid_amount");
      socket.off("receive_status");
      socket.off("receiveMessage");
      socket.off("send_Bid_amount");
      // socket.disconnect();
    };
    // Socket.removeAllListeners();
    //  socketDeclarator.removeAllListeners("receive_status");
    //   // socketDeclarator.removeAllListeners('receive_bid_amount','disconnect','JointEvent');
    //   // socketDeclarator.removeAllListeners('receive_bid_amount','disconnect','JointEvent');
    //  return () => socket.removeAllListeners("receiveMessage"),
    //           socket.removeAllListeners("receive_status") ,marginBottom: 200
  }, [details, BellSound, socket]);

  //   useEffect(() => {

  // }, []);

  // async function reconnectPlayer() {
  //   try {
  //     const videos = document.querySelector("video");
  //     const player = new WebRTCPlayer({
  //       video: videos,
  //       timeoutThreshold: 3000,
  //       type: "whep",
  //     });

  //     // console.log("player ",player)

  //     await player.load(
  //       new URL(
  //         "https://customer-gc73aqvl9oq83lia.cloudflarestream.com/359346f60f669e61d8b1efb7353292da/webRTC/play"
  //       )
  //     );
  //     player.unmute();

  //     player.on("no-media", () => {
  //       console.log("media timeout occured");
  //     });
  //     player.on("media-recovered", () => {
  //       console.log("media recovered");
  //     });

  //     // Subscribe for RTC stats: `stats:${RTCStatsType}`
  //     player.on("stats:inbound-rtp", (report) => {
  //       if (report.kind === "video") {
  //         // console.log("report");
  //       }
  //     });
  //   } catch (error) {}
  // }


  const [opendragg, setOpendragg] = React.useState(false);
  const [openChat, setOpenChat] = React.useState(true);
  const dragghandleClickOpen = () => {
    setOpendragg(true);

  };

  const dragghandleClose = () => {
    setOpendragg(false);
  
  };



  return (
    <div
      style={{
        // padding: 1,
        // height: "100lvh",
        overflow: 'hidden',
        top: 25,
        bottom: "auto",
        // marginBottom: phoneMatch === true ? 200 : "auto",
      }}
    >
      <Box>
        <div style={{ padding: 5 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography gutterBottom sx={{ color: 'text.secondary',  fontWeight: "bold",fontSize: phoneMatch === false ? 16 : 12, }}>
          {bidhistory.length} BIDS
      </Typography>
{/* 
            <p
              style={{
                color: 'text.secondary', 
                fontWeight: "bold", 
                fontSize: phoneMatch === false ? 16 : 12,
              }}
            >
              {bidhistory.length} BIDS
            </p> */}

            <Button onClick={dragghandleClickOpen} 
    variant="outlined" 
    startIcon={<PlayCircleIcon />}
    style={{ background: '#ce1b37',
    color: 'white',
    height: 25,
    fontSize: 12,
    borderRadius:5,
    visibility: mediadQuery === false ? "hidden" : "visible"
    }}>
    Watch live</Button>


<div style={{right: mediadQuery === true ? "" : 0,  display: mediadQuery === true ? "none" : "block"}}>


    <Button
                variant="outlined"
                style={{
                  borderColor: '#75747477',
                  height: 30,
                  margin: 5,
                  cursor: "pointer",    
                  textTransform: "capitalize",
                  fontSize: phoneMatch === false ? 14 : 13,
                  
                }}
                onClick={dragghandleClickOpen}
      
              >
        <PlayCircleIcon style={{color: 'red'}}  />
              </Button>

    <Button
                variant="outlined"
                style={{
                  borderColor: '#75747477',
                  height: 30,
                  margin: 5,
                  cursor: "pointer",    
                  textTransform: "capitalize",
                  fontSize: phoneMatch === false ? 14 : 13,
            
                }}
                onClick={handleCloseChat}
      
              >
        <MessageIcon  />
              </Button>
              </div>
          </div>

          {getData.map((val, i) => {
            return (
              <>
                <p
                  class="textTitle"
                  style={{
                    lineHeight: 1.2,
                    fontWeight: "bold",
                    marginTop: phoneMatch === false ? 10 : 0,
                    fontSize: phoneMatch === false ? 18 : 16,
                  }}
                >
                  {val.lot_number}. {val.title}
                </p>
              </>
            );
          })}

          <div
            style={{
              textTransform: "capitalize",
              color: "blue",
              paddingTop: 5,
              display: mediadQuery === false ? "block" : "none",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
      

                style={{
                  textTransform: "capitalize",
                  cursor: "pointer",
                  height: 25,
                  fontSize: phoneMatch === false ? 14 : 13,
                }}
                onClick={handleDetails}
              >
               View Details
              </div>

            
            </div>
          </div>

          <div
            style={{
              marginTop: mediadQuery === false ? 0 : 10,
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 5
            }}
          >
            <div style={{lineHeight: 1.5}}>
              <p style={{ fontSize: 14,lineHeight: 1,color: '#565454',  }}>
                Starting Price:
              </p>
              <p
                class="textFont"
                style={{  fontSize: 16,lineHeight: 1 }}
              >
                Php: <b style={{fontSize: 18,fontWeight: "bold", }}>{startPrice.toLocaleString()}</b>
              </p>
            </div>

            {hammerPrice === 0 ? (
              ""
            ) : (
              <div>
                <p style={{  fontSize: 14 ,lineHeight: 1,color: '#565454', }}>Current Bid:</p>
                <p
                  class="textFont"
                  style={{ fontSize: 16,lineHeight: 1 }}
                >
                  Php: <b style={{fontSize: 18,fontWeight: "bold", }}>{hammerPrice.toLocaleString()}</b> 
                </p>
              </div>
            )}
          </div>
        </div>
        {/* <video
          style={{
            display: mediadQuery === false ? "none" : "block",
            width: "100%",
          }}
          loop
          controls
          autoPlay
          muted={true}
          playsInline
        ></video> */}
        <Divider></Divider>

        <div style={{ display: mediadQuery === false ? "block" : "none" }}>
          <Box
            style={{
              margin: 1,
              backgroundColor: "black",
              paddingTop: 10,
              paddingBottom: 10,
              color: "white",
              display: mediadQuery === false ? "none" : "",
            }}
          >
            <p style={{ marginLeft: 10 }}>Lot: {lotNumber}</p>
          </Box>

          {/* <Box style={{ margin: 10 }}>
            {getData.map((val, i) => {
              return (
                <div key={i}>
                  <di style={{ display: "flex" }}>
                    {mediadQuery === false ? (
                      <di
                        style={{
                          backgroundColor: "gray",
                          // width: 40,
                          // height: 28,
                          borderRadius: 5,
                          marginRight: 5,
                        }}
                      >
                        <p
                          style={{
                            fontSize: mediadQuery === false ? 20 : 18,
                            // marginLeft: 5,
                            color: "white",
                            padding: mediadQuery === false ? 5 : 0,
                          }}
                        >
                          {val.lot_number}
                        </p>
                      </di>
                    ) : (
                      ""
                    )}

                    <p
                      style={{
                        fontSize: mediadQuery === false ? 20 : 18,
                        padding: mediadQuery === false ? 5 : 0,
                      }}
                      dangerouslySetInnerHTML={{
                        __html: val.artist,
                      }}
                    ></p>
                  </di>
                  <p
                    style={{
                      fontSize: mediadQuery === false ? 16 : 16,
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      width: 350,
                      marginBottom: 0,
                    }}
                  >
                    {val.title}
                  </p>
                </div>
              );
            })}

            <p
              style={{
                textTransform: "capitalize",
                color: "blue",
                display: mediadQuery === false ? "block" : "none",
              }}
            >
              <b style={{ cursor: "pointer" }} onClick={handleDetails}>
                Details
              </b>
            </p>
          </Box> */}

          {/* <div style={{ display: mediadQuery === false ? "block" : "none" }}>
            <Box style={{ margin: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontWeight: "bold", fontSize: 14 }}>Starting Bid</p>
                <p style={{ fontWeight: "bold", fontSize: 14 }}>
                  Php: {startPrice.toLocaleString()}
                </p>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontWeight: "bold", fontSize: 14 }}>Current Bid</p>

                <p style={{ fontWeight: "bold", fontSize: 14 }}>
                  Php: {hammerPrice.toLocaleString()}
                </p>
              </div>
            </Box>
          </div> */}
        </div>
        {/* end ng details */}
      </Box>
      {/* <Box
        style={{
          backgroundColor: "#252728",
          paddingTop: 5,
          paddingBottom: 5,
          color: "white",
          marginTop: "10px",
          display: mediadQuery === true ? "block" : "none",
        }}
      >
        <p style={{ marginLeft: 10 }}>
          <HelpOutlineIcon /> Lot Data
        </p>
      </Box> */}
      <Button
        id="sound"
        style={{ display: "none" }}
        onClick={SoundTrip}
      ></Button>
      <div>
        {/* <table
        style={{

          width: "100%",
          display: mediadQuery === true ? "block" : "none",
        }}
      >
        <tr>
          <td style={{ fontSize: 18, padding: 5, width: 155 }}>
            <p style={{ fontWeight: "bold", fontSize: 14 }}>
              Starting Bid:
            </p>
          </td>
          <td style={{ fontSize: 18, padding: 5 }}>
            <p style={{ fontWeight: "bold", fontSize: 14 }}>
              Php: {startPrice.toLocaleString()}
            </p>
          </td>
        </tr>
        <tr>
          <td style={{ fontSize: 18, padding: 5 }}>
            <p style={{ fontWeight: "bold", fontSize: 14 }}>
              Current Bid:
            </p>
          </td>
          <td style={{ fontSize: 18, padding: 5 }}>
            <p style={{ fontWeight: "bold", fontSize: 14 }}>
              Php: {hammerPrice.toLocaleString()}
            </p>
          </td>
        </tr>

      </table> */}
      </div>

      <Box
        style={{
          backgroundColor: Listcolor.headColor,
          color: Listcolor.textWhite,
        }}
        // title={("Bid History: ", `${username}`)}
      />

      {/* <Divider style={{ marginTop: 10 }} /> */}

      {/* <Box style={{ maxHeight: mediadQuery === false ? "" : 500 }}> */}
      <Box >
        {/* <Box sx={{ display: 'flex' ,marginLeft: '50%'}}>
      <CircularProgress />
    </Box> */}

        {token === null ? (
          <Box style={{ display: mediadQuery === false ? "none" : "block" }}>
            <p
              style={{
                textAlign: "center",
                padding: 100,
                fontWeight: "bold",
                fontSize: 30,
              }}
            >
              Guest
            </p>
          </Box>
        ) : (

          
          <Box sx={{ height: '100%',    paddingTop: 0 }}>
            <List
              style={{
                width: "100%",
                bgcolor: "background.paper",
                // marginTop:15,
                // padding: 5,
                // overflow: "auto",
 
                height: mediadQuery === false ? 170 : '55lvh',
                flexDirection: "column-reverse",
          
                // display: "-webkit-inline-flex",
                // "& ul": { padding: 0 },
              }}
            >
      
              {bidhistory.length ? (
                bidhistory
                  .slice(0, mediadQuery === false ? 3 : 7)
                  .map((val, i) => {
                    let StatusColor;
                    let Onlintalaga;
                    let TypeBidder;
                    let nameUser;
                    if (val.userId === userId) { nameUser = (
                        <div
                          class="bid-box"
                          style={{ float: "inline-end",}}
                        >
                          <div
                            class={
                              phoneMatch === false
                                ? "bid-text"
                                : "bid-textMobile"
                            }
                          >
                            <div
                              class={
                                phoneMatch === false
                                  ? "bid-label"
                                  : "bid-labelMobile"
                              }
                            >
                              Your bid
                            </div>
                            <div
                              class={
                                phoneMatch === false
                                  ? "bid-amount"
                                  : "bid-amountMobile"
                              }
                            >
                              {val.hammer.toLocaleString() + " Php"}
                            </div>
                          </div>
                          <div class="bid-icon">
                            <Avatar
                              sx={{
                                background: "#1976d2",
                                height: 30,
                                width: 30,
                              }}
                            >
                              <PersonIcon />
                            </Avatar>
                          </div>{" "}
                        </div>
                      );
                    } else {
                      nameUser = "";
                    }

                    if (
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                    ) {
                      Onlintalaga = true;
                      StatusColor = "green";
                    } else if (
                      val.userId === userId &&
                      val.win_status === "LOSS"
                    ) {
                      StatusColor = "red";
                    } else if (
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer !== highestNumber
                    ) {
                      StatusColor = "red";
                    } else {
                      StatusColor = "black";
                      Onlintalaga = false;
                    }

                    if (val.bidder_type === "LIVE BIDDER") {
                      TypeBidder = (
                        <div class="bidding-list">
                          <div class="bidding-method">
                            <OnlinePredictionIcon class="icon" />
                            <div class="info">
                              <div
                                class={
                                  phoneMatch === false ? "label" : "labelMobile"
                                }
                              >
                              {group === "ADMIN" ? val.email:"Online Bid" }
                              </div>
                              <div
                                class={
                                  phoneMatch === false
                                    ? "amount"
                                    : "amountMobile"
                                }
                              >
                                {val.hammer.toLocaleString() + " Php"}
                              </div>
                            </div>
                          </div>
                        </div>
                      );

               
                    } else if (val.bidder_type === "HALL BIDDER") {
                      TypeBidder = (
                        <div class="bidding-list">
                          <div class="bidding-method">
                            <AccountBalanceIcon class="icon" />
                            <div class="info">
                              <div
                                class={
                                  phoneMatch === false ? "label" : "labelMobile"
                                }
                              >
                                   {group === "ADMIN" ? val.email:"Hall Bid" }
                    
                              </div>
                              <div
                                class={
                                  phoneMatch === false
                                    ? "amount"
                                    : "amountMobile"
                                }
                              >
                                {val.hammer.toLocaleString() + " Php"}
                              </div>
                            </div>
                          </div>
                        </div>
                      );

                    } else if (val.bidder_type === "ABSENTEE BIDDER") {
                      TypeBidder = (
                        <div class="bidding-list">
                          <div class="bidding-method">
                   
                            <WebAssetIcon class="icon" />
                            <div class="info">
                              <div
                                class={
                                  phoneMatch === false ? "label" : "labelMobile"
                                }
                              >
                                 {group === "ADMIN" ? val.email:"Absentee Bid" }
                               
                              </div>
                              <div
                                class={
                                  phoneMatch === false
                                    ? "amount"
                                    : "amountMobile"
                                }
                              >
                                {val.hammer.toLocaleString() + " Php"}
                              </div>
                            </div>
                          </div>
                        </div>
                      );


                    } else if (val.bidder_type === "INTERNET BIDDER") {
                      TypeBidder = (
                        <div class="bidding-list">
                          <div class="bidding-method">
                  
                            <OnlinePredictionIcon class="icon" />
                            <div class="info">
                              <div
                                class={
                                  phoneMatch === false ? "label" : "labelMobile"
                                }
                              >
                                 {group === "ADMIN" ? val.email:"Online" }
                              </div>
                              <div
                                class={
                                  phoneMatch === false
                                    ? "amount"
                                    : "amountMobile"
                                }
                              >
                                {val.hammer.toLocaleString() + " Php"}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (val.bidder_type === "TELEPHONE BIDDER") {
                      TypeBidder = (
                        <div class="bidding-list">
                          <div class="bidding-method">
                            <TtyIcon class="icon" />
                            <div class="info">
                              <div
                                class={
                                  phoneMatch === false ? "label" : "labelMobile"
                                }
                              > {group === "ADMIN" ? val.email:"Phone Bid" }
                               
                              </div>
                              <div
                                class={
                                  phoneMatch === false
                                    ? "amount"
                                    : "amountMobile"
                                }
                              >
                                {val.hammer.toLocaleString() + " Php"}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (val.bidder_type === "FLOOR BIDDER") {
                      TypeBidder = (
                        <div class="bidding-list">
                          <div class="bidding-method">
                            <GridViewIcon class="icon" />
                            <div class="info">
                              <div
                                class={
                                  phoneMatch === false ? "label" : "labelMobile"
                                }
                              >
                                {group === "ADMIN" ? val.email:"Floor Bid" }
                                
                              </div>
                              <div
                                class={
                                  phoneMatch === false
                                    ? "amount"
                                    : "amountMobile"
                                }
                              >
                                {val.hammer.toLocaleString() + " Php"}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    //  console.log(onlineUserID === userId && val.win_status === "WIN" && val.hammer === highestNumber)

                    return (
                      <ListItem
                        key={i}
                        style={{
                          paddingBottom:  mediadQuery === false
                          ? 0:5,
                          paddingTop:  mediadQuery === false
                          ? 0:5,
                        
                        }}
                      >
                        <ListItemText
                          // gutterBottom
                          style={{ marginBottom: "0px",
                          marginTop: "0px",}}
                          align="left"
                          primary={
                            <React.Fragment>
                              <p
                                style={{
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                  color: StatusColor,
                                  fontWeight:
                                  Onlintalaga === true ? "bold" : "",
                                  fontSize:
                                    mediadQuery === false
                                      ? Onlintalaga === true
                                        ? 16
                                        : 12
                                      : Onlintalaga === true
                                      ? 12
                                      : 11,
                                }}
                                variant="body2"
                                color="text.primary"
                              >
                                {val.userId === userId ? nameUser : TypeBidder}
                              </p>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    );
                  })
              ) : (
                <Box style={{ marginTop:  mediadQuery === true ?  200:60 }}>
                  <Typography style={{ textAlign: "center" }}>
                    No Bid History
                  </Typography>
                </Box>
              )}
              {/* {bidhistory.length} */}
            </List>
          </Box>
        )}

        {token === null ? (
          <div style={{ display: mediadQuery === false ? "block" : "none" }}>
            <Box>
              <Button
                variant="contained"
                onClick={(e) =>
                  incrementCount(auctionID, setID, lotNumber, highestBid)
                }
                fullWidth={true}
                sx={{
                  borderTopRightRadius: 0,
                  borderTopLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: 0,
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                Login to bid
              </Button>
            </Box>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column' ,marginTop: 5,}}>
            <Box
              style={{
                display: mediadQuery === false ? "block" : "none",
                justifyContent: "space-between",
                backgroundColor: "#d9d9d9",
              }}
            > 
              <Box
                style={{ width: "100%", margin: "auto", textAlign: "center" ,}}
              >
                <p variant="h6" style={{fontSize:22}}>{highestBid.toLocaleString()}</p>
              </Box>

              <Button

disabled={
  bidhistory.filter(
    (val) =>
      val.userId === userId &&
      val.win_status === "WIN" &&
      val.hammer === highestNumber
  ).length ||
  status === "PENDING" ||
  status === "PAUSE" ||
  status === "SOLD"
    ? true
    : false
}
        
                read={
                  bidhistory.filter(
                    (val) =>
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                  ).length ||
                  status === "PENDING" ||
                  status === "PAUSE" ||
                  status === "SOLD"
                    ? true
                    : false
                }
                onClick={(e) =>
                  incrementCount(auctionID, setID, lotNumber, highestBid)
                }
                fullWidth={true}
                
                sx={{

                  height: 40,
                  borderTopRightRadius: 0,
                  borderTopLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: 0,
                  fontSize: 20,
                  // fontWeight: "bold",
                  backgroundColor: bidhistory.filter(
                    (val) =>
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                  ).length
                    ? "#1976d2"
                    : "#ce1b37",
              
                  ":hover": {
                    bgcolor: "#ce1b37",
                    color: "white",
                  },
                }}
              >
              <GavelIcon  style={{   color: 'white',}}/> &nbsp;
             <Typography style={{   color: 'white',}}>

{bidhistory.filter(
                    (val) =>
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                  ).length
                    ? "highest bidder"
                    : "Place bid"}
                                  </Typography> 
              </Button>
              
            </Box>
          </div>
        )}

        {token === null ? (
          <div
            style={{

              width: '26%',
              position: 'fixed',
              bottom: '0px',
              display: mediadQuery === false ? "none" : "block",
            }}
          >
            <Box>
              <Button
                variant="contained"
                onClick={(e) =>
                  incrementCount(auctionID, setID, lotNumber, highestBid)
                }
                fullWidth={true}
                sx={{
                  borderRadius: 0,
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                Login to bid
              </Button>
            </Box>
          </div>
        ) : (
          <Box
    
            style={{
              bottom: '0px',
              width: '26%',
              position: 'fixed',

              // height: '100lvh',
              // // maxHeight: phoneMatch === true ? 500 : 500,
              display: mediadQuery === false ? "none" : "block",
            }}
          >
            <Box sx={{bottom: 0,}} >
              <Box
                style={{
         
                  width: "100%",
                  margin: "auto",
                  
                  textAlign: "center",
                  height: 40,
                  backgroundColor: "rgb(217, 217, 217)",
                }}
              >
                <p
                 
                  variant="h5"
                  style={{      fontWeight: "bolder",fontSize:26}}
                >
                  {highestBid.toLocaleString()}
                </p>
              </Box>

              <Button

          
            startIcon={<GavelIcon sx={{color: 'white'}} />}
                disabled={
                  bidhistory.filter(
                    (val) =>
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                  ).length ||
                  status === "PENDING" ||
                  status === "PAUSE" ||
                  status === "SOLD"
                    ? true
                    : false
                }
                onClick={(e) =>
                  incrementCount(auctionID, setID, lotNumber, highestBid)
                }
                fullWidth={true}
                className={bidhistory.filter(
                  (val) =>
                    val.userId === userId &&
                    val.win_status === "WIN" &&
                    val.hammer === highestNumber
                ).length
                  ?  "winning-buttonBlue"
                  : "winning-buttonRed"}

                  className={bidhistory.filter(
                    (val) =>
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                  ).length
                    ?  "winning-buttonBlue"
                    : "winning-buttonRed"}
                  sx={{
                    color: 'white',
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                    fontSize: 20,
                    fontWeight: "bold",
                    background: bidhistory.filter(
                      (val) =>
                        val.userId === userId &&
                        val.win_status === "WIN" &&
                        val.hammer === highestNumber
                    ).length
                      ?  "linear-gradient(135deg, #2f94f8, #1976d2)"
                      : "linear-gradient(135deg, #f02141, #ce1b37)",
                    color: "#fff",
                    ":hover": {
                      bgcolor: "#a20b1b",
                      color: "white",
                    },
                  }}

                // sx={{
                //   color: 'white',
                //   borderTopRightRadius: 0,
                //   borderTopLeftRadius: 0,
                //   borderBottomRightRadius: 0,
                //   borderBottomLeftRadius: 0,
                //   fontSize: 20,
                //   fontWeight: "bold",
                //   background: bidhistory.filter(
                //     (val) =>
                //       val.userId === userId &&
                //       val.win_status === "WIN" &&
                //       val.hammer === highestNumber
                //   ).length
                //     ?  "linear-gradient(135deg, #2f94f8, #1976d2)"
                //     : "linear-gradient(135deg, #f02141, #ce1b37)",
                //   color: "#fff",
                //   ":hover": {
                //     bgcolor: "#a20b1b",
                //     color: "white",
                //   },
                // }}
              >
                <p
                  class="textFont"
                  style={{
                    color: "white",
                    marginBottom: 0,
                    fontWeight: "bolder",
                  }}
                >
                  {bidhistory.filter(
                    (val) =>
                      val.userId === userId &&
                      val.win_status === "WIN" &&
                      val.hammer === highestNumber
                  ).length
                    ? "highest bidder"
                    : "Place bid"}
                </p>
              </Button>
            </Box>
          </Box>
        )}



        {/* <Box
          style={{
            backgroundColor: "#252728",
            paddingTop: 5,
            paddingBottom: 5,
            color: "white",
            // marginTop: "10px",
            display: mediadQuery === false ? "block" : "none",
          }}
        >
          <p style={{ marginLeft: 10 }}>
            <UpcomingIcon /> Upcoming Lots
          </p>
        </Box> */}
        <Box
          style={{
            // marginTop: 10,
            backgroundColor: "#252728",
            display: mediadQuery === false ? "block" : "none",
          }}
        >
          <ImageRows
            open={loading}
            //  socket={Socket}
            details={dataAuction}
            mediadQuery={mediadQuery}
            lotNumberNo={lotNumber}
          />
        </Box>
      </Box>

      <Box
        style={{
          backgroundColor: "#252728",
          paddingTop: 5,
          paddingBottom: 5,
          color: "white",
          marginTop: "10px",
          display: mediadQuery === false ? "block" : "none",
        }}
      >
        <p style={{ marginLeft: 10 }}>
          <MessageIcon /> Announcement :  <p
          gutterBottom
          style={{ fontSize: 14, whiteSpace: "pre-line" }}
        >
          {announcement}
        </p>
        </p>
      </Box>

  {/* <Box
        style={{
          marginTop: 10,
          display: "flex",
          justifyContent: "space-between",
          padding: 5,
          display: mediadQuery === false ? "block" : "none",
        }}
      >
        <p
          gutterBottom
          style={{ fontSize: 14, whiteSpace: "pre-line" }}
        >
          {announcement}
        </p>
      </Box>  */}

 

      <Box
        style={{
          paddingTop: 10,
          paddingBottom: 10,

          marginTop: "10px",
          display: mediadQuery === false ? "block" : "none",
        }}
      >
        <p style={{ marginLeft: 10, textAlign: "center" }}>
          {" "}
          @{date.getFullYear()} Leon Gallery Auctions{" "}
        </p>
      </Box>

      <Dialog
        open={detailsShow}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ marginBottom: 120 }}
      >
        <DialogTitle id="alert-dialog-title">{"Details"}</DialogTitle>
        <Divider/>
 
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p
              style={{ fontSize: 14, overflow: "auto", maxHeight: 500 }}
              dangerouslySetInnerHTML={{ __html: detailsAll1 }}
            ></p>
          </DialogContentText>
        </DialogContent>
        <Divider/>
        <DialogActions>
          
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={pause}
      >
        <b style={{ fontSize: 30, color: "orange" }}> PAUSE</b>
      </Backdrop>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


      
          <Drawer1
          status={openChat}
            socket={socket}
            username={"deleonfsad@gmail.com"}
            room={22}
            handleClose={handleCloseChat}
            sender={userId}
          />
      


      <Dialog
    fullWidth={true}
      
      open={opendragg}
      onClose={dragghandleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {titleAuction}
      </DialogTitle>
      <Divider/>

      <DialogContent sx={{padding: '5px 5px'}}>
      <div style={{width: '100%'}}>
          <iframe
            id="ifvideo"
            width="100%"
            height="300"
            scrolling="no"
            frameborder="0"
            allowfullscreen=""
            src="https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?entry.rtmp.streamname=TKGUW-bCyQT&amp;playback.latencyControlMode=balancedadaptive"
          ></iframe>
        </div>
      </DialogContent>
      <Divider/>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={dragghandleClose} color="error">
          Close
        </Button>
        {/* <Button onClick={handleClose}>Subscribe</Button> */}
      </DialogActions>
    </Dialog>


    </div>
  );
}

export default RightLayout;
